module.exports = __webpack_public_path__ + "img/shengwang.312b7da4.jpg";